import Silkway from "./silkway.png";
import EAH from "./eah.svg";
import { Mail, PhoneCall } from "lucide-react";
import eng from "./eng.png";
import rus from "./rus.png";
import aze from "./aze.png";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";

const ImageComponent = () => {
	const { i18n } = useTranslation();

	const getImage = () => {
		const currentLanguage = i18n.language;
		switch (currentLanguage) {
			case "en":
				return eng;
			case "ru":
				return rus;
			case "az":
				return aze;
			default:
				return eng;
		}
	};

	return (
		<img
			className="object-contain h-max max-h-96 lg:p-10 sm:p-5 p-10"
			src={getImage()}
			alt="Exp Logo"
		/>
	);
};

function App() {
	const { t, i18n } = useTranslation();
	const currentLanguage = Cookies.get("i18next");

	const changeLanguage = (lng) => {
		i18n.changeLanguage(lng);
	};
	return (
		<>
			{/* INTRO */}
			<div>
				<div className="flex flex-col-reverse sm:flex-row justify-betweenw-full">
					<div className="flex-col sm:w-3/5 w-full flex justify-center sm:items-start gap-8 p-10 bg-[#222A36]">
						{/* LANG SELECTOR */}
						<div className="text-white px-4 py-2 flex items-center justify-center space-x-2">
							<button
								className={`block hover:text-gray-300 ${
									currentLanguage === "az" ? "font-bold" : ""
								}`}
								onClick={() => changeLanguage("az")}
								type="button"
							>
								AZ
							</button>
							<span>|</span>
							<button
								className={`block hover:text-gray-300 ${
									currentLanguage === "ru" ? "font-bold" : ""
								}`}
								onClick={() => changeLanguage("ru")}
								type="button"
							>
								RU
							</button>
							<span>|</span>
							<button
								className={`block hover:text-gray-300 ${
									currentLanguage === "en" || currentLanguage === "en-US"
										? "font-bold"
										: ""
								}`}
								onClick={() => changeLanguage("en")}
								type="button"
							>
								EN
							</button>
						</div>

						{/* NAME */}
						<h1 className="text-4xl sm:text-5xl uppercase font-gilroy text-white justify-center flex gap-2">
							<b>{t("name")}</b>
							{t("surname")}
						</h1>
						{/* INTRO TEXT */}
						<p className="text-white text-center sm:text-left">{t("intro")}</p>
						<div className="flex justify-evenly gap-20 w-full  sm:justify-start">
							<div className="flex flex-col gap-2 items-start text-white text-end">
								<div className="flex items-center gap-2">
									<span className="flex justify-center items-center w-7 h-7 bg-white rounded-full">
										<PhoneCall size="18px" stroke="#2D3540" />
									</span>
									<a href="tel:+994502119496">+994502119496</a>
								</div>

								<div className="flex w-full justify-start gap-2">
									<span className="w-7" />
									<a href="tel:+905428835445">+905428835445</a>
								</div>
							</div>

							<div className="flex flex-col gap-2 items-start text-white text-end">
								<div className="flex items-center gap-2">
									<span className="flex justify-center items-center w-7 h-7 bg-white rounded-full">
										<Mail size="18px" stroke="#2D3540" />
									</span>
									<a href="mailto:eah@eah.az">eah@eah.az</a>
								</div>
							</div>
						</div>
					</div>
					<div className="flex sm:w-2/5 w-full justify-center items-center">
						<img src={EAH} alt="EAH" className="sm:h-40 h-20 m-5" />
					</div>
				</div>
			</div>

			{/* Experience */}
			<div className="flex flex-col sm:flex sm:flex-row justify-center relative overflow-hidden bg-white">
				<div className="flex flex-col sm:flex-row border-s-2 border-[#2D3540] w-full sm:w-1/2 break-words justify-start items-center">
					<div className="bg-[#BEBCA7] sm:w-12 sm:h-full h-7 w-full" />
					<div className="flex justify-center basis-4/5">
						{/* <img
							className="object-contain h-max max-h-96 lg:p-10 sm:p-5 p-5"
							src={eng}
							alt="Exp Logo EN"
						/> */}
						<ImageComponent />
					</div>
				</div>

				<div className="flex flex-col border-s-2 border-[#2D3540] w-full sm:w-1/2 bg-white justify-around">
					<h1 className="text-3xl sm:text-5xl font-black text-[#2D3540] ms-4 my-5">
						{t("experience.title")}
					</h1>
					<ol className="relative border-gray-200 flex flex-col gap-10">
						<li className="ms-4 flex-col flex justify-center">
							<div className="absolute w-3 h-3 bg-[#2D3540] rotate-45 mt-1.5 -start-[0.45rem]" />
							<h1 className="text-lg font-bold text-gray-900">
								{t("experience.exp1.title")}
							</h1>
							<p className="text-base font-normal text-black">
								{t("experience.exp1.subtitle")}
							</p>
							<h1 className="text-lg font-bold text-gray-900 dark:text-white">
								1984 - 1987
							</h1>
						</li>
						<li className="ms-4 flex-col flex justify-center">
							<div className="absolute w-3 h-3 bg-[#2D3540] rotate-45 mt-1.5 -start-[0.45rem]" />
							<h1 className="text-lg font-bold text-gray-900">
								{t("experience.exp2.title")}
							</h1>
							<p className="text-base font-normal text-black">
								{t("experience.exp2.subtitle")}
							</p>
							<h1 className="text-lg font-bold text-gray-900 dark:text-white">
								1987 - 1990
							</h1>
						</li>
						<li className="ms-4 flex-col flex justify-center mb-10">
							<div className="absolute w-3 h-3 bg-[#2D3540] rotate-45 mt-1.5 -start-[0.45rem]" />
							<h1 className="text-lg font-semibold text-gray-900">
								{t("experience.exp3.title")}
							</h1>
							<p className="text-base font-normal text-black">
								{t("experience.exp3.subtitle")}
							</p>
							<h1 className="text-lg font-bold text-gray-900 dark:text-white">
								1987 - 1990
							</h1>
						</li>
					</ol>
				</div>
			</div>

			{/* AZAL */}
			<div className="flex bg-[#2D3540] justify-center items-center relative text-white overflow-hidden">
				<div className="flex flex-col sm:w-1/2 bg-[#2D3540] w-full">
					<ol className="relative flex flex-col gap-10 border-e-2 border-white">
						<li className="me-4 flex-col flex justify-center items-end mt-10">
							<div className="absolute w-3 h-3 bg-white rotate-45 mt-1.5 -end-[0.45rem]" />
							<h1 className="text-lg font-semibold">
								{t("experience.exp4.title")}
							</h1>
							<h1 className="text-lg font-semibold">1991 - 1992</h1>
						</li>
						<li className="me-4 flex-col flex justify-center items-end">
							<div className="absolute w-3 h-3 bg-white rotate-45 mt-1.5 -end-[0.45rem]" />
							<h1 className="text-lg font-semibold">
								{t("experience.exp5.title")}
							</h1>
							<h1 className="text-lg font-semibold">1992 - 1994</h1>
						</li>
						<li className="me-4 flex-col flex justify-center items-end mb-10">
							<div className="absolute w-3 h-3 bg-white rotate-45 mt-1.5 -end-[0.45rem]" />
							<h1 className="text-lg font-semibold">
								{t("experience.exp6.title")}
							</h1>
							<h1 className="text-lg font-regular">
								<b>1994 - 2008</b> ( {t("experience.exp6.subtitle")})
							</h1>
						</li>
					</ol>
				</div>
				<div className="sm:flex w-[calc(50%-4px)] justify-center relative hidden">
					{/* <img
							src={Azal}
							className="AzalLogo w-96 h-72 fill-white"
							alt="azal"
						/> */}
					<svg
						className="sm:w-52 fill-white m-5"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 32.545 23.306"
						fill="white"
					>
						<title>Azal</title>
						<path
							d="M300.394 318.66a4.985 4.985 0 0 1-4.726 3.42 4.982 4.982 0 0 1-4.977-4.976 4.983 4.983 0 0 1 4.977-4.977c.835 0 1.623.208 2.315.573l.178-.157a5.166 5.166 0 0 0-2.493-.638 5.204 5.204 0 0 0-5.199 5.199 5.204 5.204 0 0 0 5.199 5.198 5.208 5.208 0 0 0 4.964-3.653z"
							transform="translate(-279.305 -309.538)"
						/>
						<path
							d="M292.337 318.706c3.001-.277 5.975-.737 8.906-1.475l-.136.607c-3.75.855-6.366.934-8.77.868"
							transform="translate(-279.305 -309.538)"
						/>
						<path
							d="M292.814 318.408a52.212 52.212 0 0 0 8.645-2.141l-.139.622c-3.278 1.03-6.074 1.49-8.506 1.519"
							transform="translate(-279.305 -309.538)"
						/>
						<path
							d="M293.272 318.09c2.757-.686 5.564-1.649 8.406-2.8l-.14.625c-3.01 1.182-5.795 1.96-8.266 2.176"
							transform="translate(-279.305 -309.538)"
						/>
						<path
							d="M293.729 317.716c2.78-.845 5.514-2.115 8.22-3.638l-.172.768c-3.24 1.61-5.987 2.64-8.048 2.87"
							transform="translate(-279.305 -309.538)"
						/>
						<path
							d="M294.32 317.32a57.63 57.63 0 0 0 7.947-4.662l-.19.845c-2.592 1.655-5.18 3.026-7.757 3.817"
							transform="translate(-279.305 -309.538)"
						/>
						<path
							d="M294.775 316.83c3.07-1.941 5.733-3.915 7.886-5.932l-.231 1.033c-2.547 2.198-5.154 3.711-7.655 4.898M302.836 309.67l-.868.022a38.08 38.08 0 0 1-3.245 3.486c-1.18 1.124-2.365 2.131-3.551 3.123 2.598-1.754 5.177-3.718 7.664-6.631M279.437 331.612h7.075v.187h-7.075zM304.589 331.612h7.128v.187h-7.128z"
							transform="translate(-279.305 -309.538)"
						/>
						<path
							d="m281.229 326.338-.836 1.666h1.666zm-.994 2-.429.835c-.095.195-.444.058-.348-.153l1.596-3.147c.032-.069.106-.1.175-.1.068 0 .132.031.169.1l1.592 3.13c.137.228-.254.36-.354.154l-.413-.82h-1.988zM283.958 328.889h2.258c.248 0 .254.362 0 .378h-2.612c-.207 0-.27-.17-.154-.318l2.37-2.814h-2.142c-.233 0-.238-.346 0-.362h2.517c.217 0 .275.17.153.329zM287.332 328.904h2.089c.222 0 .254.363 0 .363h-2.227a.235.235 0 0 1-.243-.242v-3.016c0-.127.095-.237.243-.237h2.232c.227 0 .217.352-.005.352h-2.089v1.237h1.989c.211 0 .222.35 0 .35h-1.989zM290.717 327.675h1.068c.693 0 .994-.33.984-.737-.005-.445-.37-.802-.984-.802h-1.068zm0 .341v1.051c0 .25-.386.25-.386.006v-3.11c0-.114.079-.19.195-.19h1.254c.915 0 1.38.531 1.38 1.165 0 .547-.291.943-.941 1.056l.857.949c.2.206-.09.444-.265.26l-1.068-1.187h-1.026zM294.197 328.91h1.185c.465 0 .978-.127.978-.681 0-.435-.36-.621-.82-.621h-1.343zm0-2.78v1.12h1.079c.454 0 .851-.126.851-.527 0-.473-.54-.593-.867-.593zm1.185 3.137h-1.376a.198.198 0 0 1-.195-.198v-3.1c0-.109.09-.197.195-.197h1.254c.492 0 1.253.17 1.253.95 0 .287-.132.54-.407.655.386.126.65.407.65.852 0 .818-.708 1.038-1.374 1.038zM298.82 326.338l-.836 1.666h1.666zm-.995 2-.428.835c-.096.195-.444.058-.35-.153l1.598-3.147c.032-.069.105-.1.174-.1.069 0 .132.031.17.1l1.592 3.13c.137.228-.254.36-.355.154l-.413-.82h-1.988zM301.088 325.966c0-.261.397-.256.397 0v3.12c0 .24-.397.25-.397 0zM304.097 326.128h-1.015a.179.179 0 0 1 0-.356h1.19a.2.2 0 0 1 .19.179v2.065c.005.727-.666 1.256-1.364 1.256-.672 0-1.217-.486-1.254-1.132-.015-.249.37-.297.392-.006.031.49.417.776.862.776.513 0 1-.383 1-.895zM306.567 326.338l-.835 1.666h1.665zm-.994 2-.428.835c-.095.195-.445.058-.35-.153l1.598-3.147c.031-.069.105-.1.174-.1.069 0 .132.031.17.1l1.591 3.13c.138.228-.254.36-.354.154l-.412-.82h-1.99zM311.258 325.96c0-.225.402-.236.402 0v3.062c0 .267-.365.294-.476.107l-1.977-2.674.042.737v1.883c0 .262-.402.268-.402 0v-3.057c0-.267.296-.31.428-.112l2.036 2.748-.053-.806v-1.889zM288.907 330.654l-.579 1.165h1.153zm-.689 1.398-.296.584c-.066.137-.307.04-.241-.107l1.105-2.2c.022-.049.073-.072.12-.072.048 0 .092.023.118.071l1.101 2.19c.095.16-.175.251-.245.107l-.286-.573zM290.476 330.393c0-.183.274-.18.274 0v2.189c0 .168-.274.176-.274 0zM291.574 331.588h.739c.48 0 .688-.23.68-.515-.004-.311-.256-.561-.68-.561h-.74zm0 .239v.735c0 .174-.268.174-.268.004v-2.176c0-.08.055-.132.136-.132h.867c.633 0 .955.371.955.815 0 .383-.201.66-.651.739l.593.663c.138.144-.062.31-.184.182l-.739-.83zM293.85 332.702c-.1 0-.14-.05-.14-.14v-2.173c0-.178.271-.178.271 0v2.063h1.369c.186 0 .186.25 0 .25zM295.792 330.393c0-.183.274-.18.274 0v2.189c0 .168-.274.176-.274 0zM298.273 330.378c0-.157.278-.165.278 0v2.152c0 .187-.252.206-.33.075l-1.368-1.879.029.518v1.323c0 .184-.278.188-.278 0v-2.148c0-.187.205-.218.296-.079l1.41 1.931-.037-.566v-1.327zM299.414 332.448h1.446c.153 0 .175.254 0 .254h-1.541a.163.163 0 0 1-.168-.17v-2.112c0-.089.066-.166.168-.166h1.544c.158 0 .15.246-.004.246h-1.445v.866h1.376c.146 0 .153.247 0 .247h-1.376zM301.562 332.066c.095.305.501.371.794.371.311 0 .794-.095.794-.467 0-.32-.384-.346-.787-.38-.505-.04-1.046-.087-1.046-.636 0-.485.556-.702 1.002-.702.384 0 .864.092 1.018.511.054.147-.194.214-.249.089-.11-.28-.502-.328-.765-.328-.245 0-.72.1-.72.434 0 .32.365.354.79.387.5.044 1.039.07 1.039.622 0 .563-.626.735-1.076.735-.373 0-.944-.128-1.065-.57-.044-.162.241-.217.27-.066"
							transform="translate(-279.305 -309.538)"
						/>
					</svg>
				</div>
			</div>

			{/* VICE */}
			<div className="font-gilroy-bold flex flex-col sm:flex-row text-[#2D3540] gap-3 items-center justify-center my-5">
				<div className="flex flex-col items-center">
					<svg
						className="h-44 fill-[#2D3540] m-5"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 32.545 23.306"
						fill="white"
					>
						<title>Azal</title>
						<path
							d="M300.394 318.66a4.985 4.985 0 0 1-4.726 3.42 4.982 4.982 0 0 1-4.977-4.976 4.983 4.983 0 0 1 4.977-4.977c.835 0 1.623.208 2.315.573l.178-.157a5.166 5.166 0 0 0-2.493-.638 5.204 5.204 0 0 0-5.199 5.199 5.204 5.204 0 0 0 5.199 5.198 5.208 5.208 0 0 0 4.964-3.653z"
							transform="translate(-279.305 -309.538)"
						/>
						<path
							d="M292.337 318.706c3.001-.277 5.975-.737 8.906-1.475l-.136.607c-3.75.855-6.366.934-8.77.868"
							transform="translate(-279.305 -309.538)"
						/>
						<path
							d="M292.814 318.408a52.212 52.212 0 0 0 8.645-2.141l-.139.622c-3.278 1.03-6.074 1.49-8.506 1.519"
							transform="translate(-279.305 -309.538)"
						/>
						<path
							d="M293.272 318.09c2.757-.686 5.564-1.649 8.406-2.8l-.14.625c-3.01 1.182-5.795 1.96-8.266 2.176"
							transform="translate(-279.305 -309.538)"
						/>
						<path
							d="M293.729 317.716c2.78-.845 5.514-2.115 8.22-3.638l-.172.768c-3.24 1.61-5.987 2.64-8.048 2.87"
							transform="translate(-279.305 -309.538)"
						/>
						<path
							d="M294.32 317.32a57.63 57.63 0 0 0 7.947-4.662l-.19.845c-2.592 1.655-5.18 3.026-7.757 3.817"
							transform="translate(-279.305 -309.538)"
						/>
						<path
							d="M294.775 316.83c3.07-1.941 5.733-3.915 7.886-5.932l-.231 1.033c-2.547 2.198-5.154 3.711-7.655 4.898M302.836 309.67l-.868.022a38.08 38.08 0 0 1-3.245 3.486c-1.18 1.124-2.365 2.131-3.551 3.123 2.598-1.754 5.177-3.718 7.664-6.631M279.437 331.612h7.075v.187h-7.075zM304.589 331.612h7.128v.187h-7.128z"
							transform="translate(-279.305 -309.538)"
						/>
						<path
							d="m281.229 326.338-.836 1.666h1.666zm-.994 2-.429.835c-.095.195-.444.058-.348-.153l1.596-3.147c.032-.069.106-.1.175-.1.068 0 .132.031.169.1l1.592 3.13c.137.228-.254.36-.354.154l-.413-.82h-1.988zM283.958 328.889h2.258c.248 0 .254.362 0 .378h-2.612c-.207 0-.27-.17-.154-.318l2.37-2.814h-2.142c-.233 0-.238-.346 0-.362h2.517c.217 0 .275.17.153.329zM287.332 328.904h2.089c.222 0 .254.363 0 .363h-2.227a.235.235 0 0 1-.243-.242v-3.016c0-.127.095-.237.243-.237h2.232c.227 0 .217.352-.005.352h-2.089v1.237h1.989c.211 0 .222.35 0 .35h-1.989zM290.717 327.675h1.068c.693 0 .994-.33.984-.737-.005-.445-.37-.802-.984-.802h-1.068zm0 .341v1.051c0 .25-.386.25-.386.006v-3.11c0-.114.079-.19.195-.19h1.254c.915 0 1.38.531 1.38 1.165 0 .547-.291.943-.941 1.056l.857.949c.2.206-.09.444-.265.26l-1.068-1.187h-1.026zM294.197 328.91h1.185c.465 0 .978-.127.978-.681 0-.435-.36-.621-.82-.621h-1.343zm0-2.78v1.12h1.079c.454 0 .851-.126.851-.527 0-.473-.54-.593-.867-.593zm1.185 3.137h-1.376a.198.198 0 0 1-.195-.198v-3.1c0-.109.09-.197.195-.197h1.254c.492 0 1.253.17 1.253.95 0 .287-.132.54-.407.655.386.126.65.407.65.852 0 .818-.708 1.038-1.374 1.038zM298.82 326.338l-.836 1.666h1.666zm-.995 2-.428.835c-.096.195-.444.058-.35-.153l1.598-3.147c.032-.069.105-.1.174-.1.069 0 .132.031.17.1l1.592 3.13c.137.228-.254.36-.355.154l-.413-.82h-1.988zM301.088 325.966c0-.261.397-.256.397 0v3.12c0 .24-.397.25-.397 0zM304.097 326.128h-1.015a.179.179 0 0 1 0-.356h1.19a.2.2 0 0 1 .19.179v2.065c.005.727-.666 1.256-1.364 1.256-.672 0-1.217-.486-1.254-1.132-.015-.249.37-.297.392-.006.031.49.417.776.862.776.513 0 1-.383 1-.895zM306.567 326.338l-.835 1.666h1.665zm-.994 2-.428.835c-.095.195-.445.058-.35-.153l1.598-3.147c.031-.069.105-.1.174-.1.069 0 .132.031.17.1l1.591 3.13c.138.228-.254.36-.354.154l-.412-.82h-1.99zM311.258 325.96c0-.225.402-.236.402 0v3.062c0 .267-.365.294-.476.107l-1.977-2.674.042.737v1.883c0 .262-.402.268-.402 0v-3.057c0-.267.296-.31.428-.112l2.036 2.748-.053-.806v-1.889zM288.907 330.654l-.579 1.165h1.153zm-.689 1.398-.296.584c-.066.137-.307.04-.241-.107l1.105-2.2c.022-.049.073-.072.12-.072.048 0 .092.023.118.071l1.101 2.19c.095.16-.175.251-.245.107l-.286-.573zM290.476 330.393c0-.183.274-.18.274 0v2.189c0 .168-.274.176-.274 0zM291.574 331.588h.739c.48 0 .688-.23.68-.515-.004-.311-.256-.561-.68-.561h-.74zm0 .239v.735c0 .174-.268.174-.268.004v-2.176c0-.08.055-.132.136-.132h.867c.633 0 .955.371.955.815 0 .383-.201.66-.651.739l.593.663c.138.144-.062.31-.184.182l-.739-.83zM293.85 332.702c-.1 0-.14-.05-.14-.14v-2.173c0-.178.271-.178.271 0v2.063h1.369c.186 0 .186.25 0 .25zM295.792 330.393c0-.183.274-.18.274 0v2.189c0 .168-.274.176-.274 0zM298.273 330.378c0-.157.278-.165.278 0v2.152c0 .187-.252.206-.33.075l-1.368-1.879.029.518v1.323c0 .184-.278.188-.278 0v-2.148c0-.187.205-.218.296-.079l1.41 1.931-.037-.566v-1.327zM299.414 332.448h1.446c.153 0 .175.254 0 .254h-1.541a.163.163 0 0 1-.168-.17v-2.112c0-.089.066-.166.168-.166h1.544c.158 0 .15.246-.004.246h-1.445v.866h1.376c.146 0 .153.247 0 .247h-1.376zM301.562 332.066c.095.305.501.371.794.371.311 0 .794-.095.794-.467 0-.32-.384-.346-.787-.38-.505-.04-1.046-.087-1.046-.636 0-.485.556-.702 1.002-.702.384 0 .864.092 1.018.511.054.147-.194.214-.249.089-.11-.28-.502-.328-.765-.328-.245 0-.72.1-.72.434 0 .32.365.354.79.387.5.044 1.039.07 1.039.622 0 .563-.626.735-1.076.735-.373 0-.944-.128-1.065-.57-.044-.162.241-.217.27-.066"
							transform="translate(-279.305 -309.538)"
						/>
					</svg>
					<p className="w-1/2 text-center">
						{t("experience.exp7.title")}
						<br />
						2008 - 2012
					</p>
				</div>

				<div className="h-[1px] sm:h-48 sm:w-[2px] bg-black w-2/3" />

				<div className="flex flex-col items-center">
					<img
						src={Silkway}
						alt="Silkway"
						className="h-24 m-5 object-contain"
					/>
					<p className="w-1/2 text-center">
						{t("experience.exp8.title")}
						<br />
						2012 - 2015
					</p>
				</div>

				<div className="h-[1px] sm:h-48 sm:w-[2px] bg-black w-2/3" />

				<div className="flex flex-col items-center">
					<svg
						className="h-44 fill-[#2D3540] m-5"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 32.545 23.306"
						fill="white"
					>
						<title>Azal</title>
						<path
							d="M300.394 318.66a4.985 4.985 0 0 1-4.726 3.42 4.982 4.982 0 0 1-4.977-4.976 4.983 4.983 0 0 1 4.977-4.977c.835 0 1.623.208 2.315.573l.178-.157a5.166 5.166 0 0 0-2.493-.638 5.204 5.204 0 0 0-5.199 5.199 5.204 5.204 0 0 0 5.199 5.198 5.208 5.208 0 0 0 4.964-3.653z"
							transform="translate(-279.305 -309.538)"
						/>
						<path
							d="M292.337 318.706c3.001-.277 5.975-.737 8.906-1.475l-.136.607c-3.75.855-6.366.934-8.77.868"
							transform="translate(-279.305 -309.538)"
						/>
						<path
							d="M292.814 318.408a52.212 52.212 0 0 0 8.645-2.141l-.139.622c-3.278 1.03-6.074 1.49-8.506 1.519"
							transform="translate(-279.305 -309.538)"
						/>
						<path
							d="M293.272 318.09c2.757-.686 5.564-1.649 8.406-2.8l-.14.625c-3.01 1.182-5.795 1.96-8.266 2.176"
							transform="translate(-279.305 -309.538)"
						/>
						<path
							d="M293.729 317.716c2.78-.845 5.514-2.115 8.22-3.638l-.172.768c-3.24 1.61-5.987 2.64-8.048 2.87"
							transform="translate(-279.305 -309.538)"
						/>
						<path
							d="M294.32 317.32a57.63 57.63 0 0 0 7.947-4.662l-.19.845c-2.592 1.655-5.18 3.026-7.757 3.817"
							transform="translate(-279.305 -309.538)"
						/>
						<path
							d="M294.775 316.83c3.07-1.941 5.733-3.915 7.886-5.932l-.231 1.033c-2.547 2.198-5.154 3.711-7.655 4.898M302.836 309.67l-.868.022a38.08 38.08 0 0 1-3.245 3.486c-1.18 1.124-2.365 2.131-3.551 3.123 2.598-1.754 5.177-3.718 7.664-6.631M279.437 331.612h7.075v.187h-7.075zM304.589 331.612h7.128v.187h-7.128z"
							transform="translate(-279.305 -309.538)"
						/>
						<path
							d="m281.229 326.338-.836 1.666h1.666zm-.994 2-.429.835c-.095.195-.444.058-.348-.153l1.596-3.147c.032-.069.106-.1.175-.1.068 0 .132.031.169.1l1.592 3.13c.137.228-.254.36-.354.154l-.413-.82h-1.988zM283.958 328.889h2.258c.248 0 .254.362 0 .378h-2.612c-.207 0-.27-.17-.154-.318l2.37-2.814h-2.142c-.233 0-.238-.346 0-.362h2.517c.217 0 .275.17.153.329zM287.332 328.904h2.089c.222 0 .254.363 0 .363h-2.227a.235.235 0 0 1-.243-.242v-3.016c0-.127.095-.237.243-.237h2.232c.227 0 .217.352-.005.352h-2.089v1.237h1.989c.211 0 .222.35 0 .35h-1.989zM290.717 327.675h1.068c.693 0 .994-.33.984-.737-.005-.445-.37-.802-.984-.802h-1.068zm0 .341v1.051c0 .25-.386.25-.386.006v-3.11c0-.114.079-.19.195-.19h1.254c.915 0 1.38.531 1.38 1.165 0 .547-.291.943-.941 1.056l.857.949c.2.206-.09.444-.265.26l-1.068-1.187h-1.026zM294.197 328.91h1.185c.465 0 .978-.127.978-.681 0-.435-.36-.621-.82-.621h-1.343zm0-2.78v1.12h1.079c.454 0 .851-.126.851-.527 0-.473-.54-.593-.867-.593zm1.185 3.137h-1.376a.198.198 0 0 1-.195-.198v-3.1c0-.109.09-.197.195-.197h1.254c.492 0 1.253.17 1.253.95 0 .287-.132.54-.407.655.386.126.65.407.65.852 0 .818-.708 1.038-1.374 1.038zM298.82 326.338l-.836 1.666h1.666zm-.995 2-.428.835c-.096.195-.444.058-.35-.153l1.598-3.147c.032-.069.105-.1.174-.1.069 0 .132.031.17.1l1.592 3.13c.137.228-.254.36-.355.154l-.413-.82h-1.988zM301.088 325.966c0-.261.397-.256.397 0v3.12c0 .24-.397.25-.397 0zM304.097 326.128h-1.015a.179.179 0 0 1 0-.356h1.19a.2.2 0 0 1 .19.179v2.065c.005.727-.666 1.256-1.364 1.256-.672 0-1.217-.486-1.254-1.132-.015-.249.37-.297.392-.006.031.49.417.776.862.776.513 0 1-.383 1-.895zM306.567 326.338l-.835 1.666h1.665zm-.994 2-.428.835c-.095.195-.445.058-.35-.153l1.598-3.147c.031-.069.105-.1.174-.1.069 0 .132.031.17.1l1.591 3.13c.138.228-.254.36-.354.154l-.412-.82h-1.99zM311.258 325.96c0-.225.402-.236.402 0v3.062c0 .267-.365.294-.476.107l-1.977-2.674.042.737v1.883c0 .262-.402.268-.402 0v-3.057c0-.267.296-.31.428-.112l2.036 2.748-.053-.806v-1.889zM288.907 330.654l-.579 1.165h1.153zm-.689 1.398-.296.584c-.066.137-.307.04-.241-.107l1.105-2.2c.022-.049.073-.072.12-.072.048 0 .092.023.118.071l1.101 2.19c.095.16-.175.251-.245.107l-.286-.573zM290.476 330.393c0-.183.274-.18.274 0v2.189c0 .168-.274.176-.274 0zM291.574 331.588h.739c.48 0 .688-.23.68-.515-.004-.311-.256-.561-.68-.561h-.74zm0 .239v.735c0 .174-.268.174-.268.004v-2.176c0-.08.055-.132.136-.132h.867c.633 0 .955.371.955.815 0 .383-.201.66-.651.739l.593.663c.138.144-.062.31-.184.182l-.739-.83zM293.85 332.702c-.1 0-.14-.05-.14-.14v-2.173c0-.178.271-.178.271 0v2.063h1.369c.186 0 .186.25 0 .25zM295.792 330.393c0-.183.274-.18.274 0v2.189c0 .168-.274.176-.274 0zM298.273 330.378c0-.157.278-.165.278 0v2.152c0 .187-.252.206-.33.075l-1.368-1.879.029.518v1.323c0 .184-.278.188-.278 0v-2.148c0-.187.205-.218.296-.079l1.41 1.931-.037-.566v-1.327zM299.414 332.448h1.446c.153 0 .175.254 0 .254h-1.541a.163.163 0 0 1-.168-.17v-2.112c0-.089.066-.166.168-.166h1.544c.158 0 .15.246-.004.246h-1.445v.866h1.376c.146 0 .153.247 0 .247h-1.376zM301.562 332.066c.095.305.501.371.794.371.311 0 .794-.095.794-.467 0-.32-.384-.346-.787-.38-.505-.04-1.046-.087-1.046-.636 0-.485.556-.702 1.002-.702.384 0 .864.092 1.018.511.054.147-.194.214-.249.089-.11-.28-.502-.328-.765-.328-.245 0-.72.1-.72.434 0 .32.365.354.79.387.5.044 1.039.07 1.039.622 0 .563-.626.735-1.076.735-.373 0-.944-.128-1.065-.57-.044-.162.241-.217.27-.066"
							transform="translate(-279.305 -309.538)"
						/>
					</svg>
					<p className="w-1/2 text-center">
						{t("experience.exp9.title")}
						<br />
						2015 - 2023
					</p>
				</div>
			</div>

			{/* AWARDS */}
			<div className="bg-[#BEBCA7] flex justify-center text-white w-full">
				<div className="w-[calc(100%-50px)] sm:w-[calc(100%-100px)] bg-[#2D3540]">
					<h1 className="text-3xl sm:text-5xl font-bold ms-4 my-5 py-5">
						{t("awards.title")}
					</h1>
					<ul className="list-disc pl-10 gap-5 space-y-2 pr-10">
						{[...Array(21)].map((_, index) => {
							// index + 1 for 0 to 21
							const awardKey = `award${21 - index}`;
							return <li key={awardKey}>{t(`awards.${awardKey}`)}</li>;
						})}
					</ul>
				</div>
			</div>

			{/* BOTTOM */}
			<div className="w-full h-20 bg-[#2D3540]" />
		</>
	);
}

export default App;
